import { render, staticRenderFns } from "./app-newer-gift-coupon.vue?vue&type=template&id=71b55d4e"
import script from "./app-newer-gift-coupon.vue?vue&type=script&lang=js"
export * from "./app-newer-gift-coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports